import usePrivateAxios from '@/common/api/usePrivateAxios'
import { defaultTransformerResponse } from '@/common/constants/defaultTransformerResponse.constant'
import { Mapper } from '@/common/services/mapper'
import { MetaResponse } from '@/common/types/metaResponse'
import { keepPreviousData, useQuery } from '@tanstack/react-query'

type UseTmaisUserConsumptionsProps<T> = {
  userId: string
  filters?: {
    page?: number
    establishmentCompanyId?: string
  }
  mapper?: (data: any) => T
}

export const useTmaisUserConsumptions = <T,>({
  userId,
  filters: { page, establishmentCompanyId } = {},
  mapper = Mapper.default<T>(),
}: UseTmaisUserConsumptionsProps<T>) => {
  const privateAxios = usePrivateAxios()

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    isPending,
    ...rest
  } = useQuery({
    queryKey: ['tmaisUserConsumptions', userId, page, establishmentCompanyId],
    queryFn: () => {
      return privateAxios.get('/tmais/consumptions', {
        params: {
          page,
          'q[buyer_id_eq]': userId,
          'q[establishment_company_id_eq]': establishmentCompanyId,
        },
      })
    },
    select: (data: { data: { data: any[]; meta: MetaResponse } }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      }
    },
    placeholderData: keepPreviousData,
    enabled: !!userId,
  })

  return { data, meta, isPending, ...rest }
}
